import { AcornsIcon } from '@acorns/icons'
import { Drawer, theme } from '@acorns/web-components'
import styled from 'styled-components'

import { DetailHeader, Text } from '../shared/SectionDetails'
import {
  RECAP_XS_BREAKPOINT,
  fonts,
  orangeGradientText,
  publishingColors,
} from '../styles'

export const GainLossWrapper = styled.div`
  pointer-events: none;
  width: fit-content;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    pointer-events: auto;
  }
`

export const GainLossContainer = styled.div<{ isMarket: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
  width: 100%;
`

export const MarketUnit = styled.div<{ isActive: boolean }>`
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  transform: translate(${(props) => (props.isActive ? '0' : '-100%')}, 0);
  transition:
    opacity 450ms cubic-bezier(0.64, 0.04, 0.35, 1),
    transform 450ms cubic-bezier(0.64, 0.04, 0.35, 1);
  will-change: opacity, transform;
`

export const TotalUnit = styled(MarketUnit)`
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  transform: translate(${(props) => (props.isActive ? '-100%' : '0')}, 0);
`

export const ChangeAmount = styled.p`
  ${fonts.AN_30_600_38}
  ${orangeGradientText}
  margin-bottom: 10px;
  margin: 0;
  padding: 0;
  position: absolute;
  white-space: nowrap;
`

export const ToggleArrowWrapper = styled.div`
  display: flex;
  margin-top: 20px;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    display: none;
  }
`

export const ToggleTabWrapper = styled.div`
  display: none;
  margin-top: 10px;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    display: flex;
  }
`

export const IconWrapper = styled.button`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 26px;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 26px;
  justify-content: center;
  opacity: 1;
  pointer-events: initial;
  width: 26px;

  &:disabled,
  &[disabled] {
    cursor: none;
    opacity: 0.4;
    pointer-events: none;
  }

  &:first-child {
    margin-right: 15px;
  }

  path {
    &[stroke] {
      stroke: ${theme.colors.white};
    }
  }
`

export const ToggleTab = styled.button`
  background-color: ${theme.colors.beige};
  border: 0;
  cursor: pointer;
  height: 2px;
  width: 15px;

  &:disabled,
  &[disabled] {
    cursor: none;
    opacity: 0.2;
    pointer-events: none;
  }

  &:first-child {
    margin-right: 4px;
  }
`

export const AccountValue = styled(DetailHeader)`
  margin-bottom: 10px;
`

// compensate ChangeAmount being absolute for the animating while is overflow-ed
export const Indicator = styled(Text)`
  margin-top: 48px;
`

export const StyledIcon = styled(AcornsIcon)`
  display: inline;

  & > path {
    fill: ${publishingColors.tan};
  }
`

export const StyledModalDrawer = styled(Drawer)`
  padding-bottom: 10px;
  width: 100%;
`

export const ModalContent = styled.div`
  color: ${theme.colors.slate};
  margin-top: -40px;
`

export const ModalHeader = styled.h2`
  ${fonts.AN_22_600_30};
  margin-bottom: 20px;
  padding-right: 40px;
`

export const ModalText = styled.p`
  ${fonts.AN_14_600_22};
  font-weight: 400;
  margin-bottom: 10px;
  padding-right: 40px;
  &:last-child {
    margin-bottom: 30px;
  }
`
